/*! art-engine storefront bundle, commit b119938, built 2026-11-04T03:28:46.843Z. Generated by scripts/build-bundle.mjs; edit the files in JS/ and CSS/, not this. */
(function () {
  if (window.ADC) { console.warn('[adc] storefront.js skipped: this page also loads the separate art-engine scripts. Remove those tags.'); return; }
  if (document.readyState === 'loading' && !document.body) console.warn('[adc] load storefront.js with defer (or at the end of <body>), not as a plain <script> in <head>.');
  var isProductPage = !!document.querySelector("#product-price, form.product-form");

  /* ===== JS/storefront-core.js ===== */
  try { (function () {
// Shared setup for the storefront-*.js storefront scripts: where the published data lives, tiny
// helpers, and the ADC_READY gate. Load this FIRST.
//
// Storefronts read the store's PUBLISHED SNAPSHOT (JSON files the dashboard's Publish button
// writes to the public `storefront-snapshots` bucket — see adc-platform/CLAUDE.md, "Publish
// workflow"), never the live database. So dashboard edits only appear after Publish, and the
// storefront makes no database queries and carries no database key.
//
// Which store: the page sets window.ADC_STORE_SLUG (e.g. 'seth-royal-kroft') in its loader
// embed BEFORE this script. Each store's Webflow site has its own embed, so this is explicit
// per site rather than guessed from the hostname.

window.ADC_SNAPSHOT_ROOT =
  'https://avqqeilgmvegolwdtnjc.supabase.co/storage/v1/object/public/storefront-snapshots';

async function fetchJson(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`${res.status} ${url}`);
  return res.json();
}

// A store suspended for non-payment: the platform's billing job writes `suspended: true` into the store's
// latest.json (adc-platform, "Billing"), and the storefront then shows only this notice. Anything else
// (false, missing, a failed check) leaves the storefront exactly as it was.
function showSuspendedNotice() {
  const show = () => {
    const box = document.createElement('div');
    box.setAttribute('role', 'alert');
    box.style.cssText =
      'position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;' +
      'background:#fff;color:#222;font:16px/1.5 system-ui,sans-serif;text-align:center;padding:2rem';
    box.textContent = 'This store is temporarily unavailable. Please check back soon.';
    document.body.appendChild(box);
  };
  if (document.body) show();
  else document.addEventListener('DOMContentLoaded', show);
}

const fileCache = new Map();

// --- Conditional components: data-adc-show / data-adc-hide ---------------------------------------
// Elements built in the Designer that appear only while a condition ("flag") holds, e.g. a sale's top
// bar. Flags are plain names set by the storefront scripts: `sale` while a sale runs, `sale:<component>`
// while a sale runs AND the dashboard switched that component on (storefront-sale.js). On any element:
//   data-adc-show="sale:top-bar"   hidden unless that flag is on. Several names, space-separated = any of them.
//   data-adc-hide="sale"           shown unless that flag is on.
//   data-adc-dismiss               (inside a data-adc-show element) a close button: hides that element and
//                                  remembers it in this browser until the flag's version changes (a new sale).
// <html data-adc-flags="sale sale:top-bar"> lists the flags that are on, for CSS (html[data-adc-flags~="sale"]).
// The element keeps its own Designer display (flex, grid...); hiding is this one rule, so it can't fight
// the Designer. The same rule also belongs in Site Settings > Custom Code > Head as a <style>, so nothing
// flashes before this script runs.
const FLAG_STYLE = '[data-adc-show]:not([data-adc-visible]),[data-adc-hide][data-adc-hidden]{display:none!important}';
(function injectFlagStyle() {
  const style = document.createElement('style');
  style.textContent = FLAG_STYLE;
  (document.head || document.documentElement).appendChild(style);
})();

const DISMISS_KEY = 'adc-dismissed';
function readDismissed() {
  try {
    return new Set(JSON.parse(localStorage.getItem(DISMISS_KEY) || '[]'));
  } catch {
    return new Set();
  }
}

window.ADC = {
  esc(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  },
  // Category name -> URL slug (`/artworks?category=<slug>`). One rule for every page that links to a
  // category, so the homepage cards and the /artworks sidebar can never disagree.
  slugify(name) {
    return String(name).toLowerCase().replace(/['\u2019]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  },
  // The store's current published version: {version, base, built_at, artwork_count}. latest.json
  // is the only mutable file (30s cache); everything it points at is immutable.
  latest: (async function loadLatest() {
    const slug = window.ADC_STORE_SLUG;
    if (!slug) {
      console.error('[adc-store] window.ADC_STORE_SLUG is not set — set it in the loader embed before storefront-core.js.');
      return null;
    }
    try {
      const latest = await fetchJson(`${window.ADC_SNAPSHOT_ROOT}/${encodeURIComponent(slug)}/latest.json`);
      if (latest.suspended === true) {
        showSuspendedNotice();
        return null; // the other storefront scripts treat this like "no snapshot" and stay empty
      }
      return latest;
    } catch (e) {
      console.error(`[adc-store] no published snapshot for "${slug}" — has the store been published? (${e.message})`);
      return null;
    }
  })(),
  // One file from the current snapshot ('catalog.json', 'categories.json', 'artworks.json',
  // 'artwork/<id>.json'). Memoized, so every script sharing a file shares one request.
  // Resolves null when the store has no snapshot; rejects if the file itself is missing.
  async file(path) {
    const latest = await window.ADC.latest;
    if (!latest) return null;
    if (!fileCache.has(path)) fileCache.set(path, fetchJson(`${latest.base}/${path}`));
    return fileCache.get(path);
  },
  // --- Designer sample items ("templates") -------------------------------------------------
  // Repeated items (cards, links, option radios...) are real elements built in the Webflow
  // Designer, so they can be styled and animated there. The one marked data-adc-template inside a
  // mount is the SAMPLE: render() clones it once per data row, fills the clone, and removes the
  // sample. Only values are injected -- never markup. Fields a sample element can ask for:
  //   data-adc-bind="field"   textContent = value      (keep it on an element with no children)
  //   data-adc-href="field"   href  = value
  //   data-adc-src="field"    src   = value            (srcset/sizes are dropped so src wins)
  //   data-adc-alt="field"    alt   = value
  //   data-adc-attr="attr=field, attr=field"   any other attribute (id, value, data-*, for ...);
  //                           an attribute whose field is null/missing is left off
  //   data-adc-current        gets class w--current + aria-current="page" when the row is `current`
  //   data-adc-placeholder    sample content shown only in the Designer; hidden on the published page
  //                           until it has been filled (the marker is then removed)
  fill(root, values) {
    const targets = [root, ...root.querySelectorAll('[data-adc-bind],[data-adc-href],[data-adc-src],[data-adc-alt],[data-adc-attr]')];
    for (const el of targets) {
      // Unrendered samples are only filled via render() (their clones no longer carry the marker).
      if (el.closest('[data-adc-template]')) continue;
      // A broad fill() (e.g. storefront-artwork-detail.js calling fill(document.body, {...}) so any
      // page element can ask for the artwork's title/image) must not reach into another
      // renderer's already-rendered catalog items just because a field name coincides.
      // Bug this fixes: the artwork's own `image` field was overwriting every frame radio's
      // data-frame-image (also field "image") on every page load, because fill() matched
      // purely by field name with no idea which renderer owned which element. render()'s own
      // fill(node, item.values) calls are unaffected — node is still detached (not yet under
      // its mount) when they run, so this guard only ever blocks OTHER callers from reaching in.
      if (el.closest('[data-adc-mount]')) continue;
      let touched = false;
      const set = (attr, apply) => {
        const field = el.getAttribute?.(attr);
        if (field && field in values) {
          apply(String(values[field] ?? ''));
          touched = true;
        }
      };
      set('data-adc-bind', (v) => { el.textContent = v; });
      set('data-adc-href', (v) => el.setAttribute('href', v));
      set('data-adc-src', (v) => {
        el.removeAttribute('srcset');
        el.removeAttribute('sizes');
        el.setAttribute('src', v);
      });
      set('data-adc-alt', (v) => el.setAttribute('alt', v));
      const pairs = el.getAttribute?.('data-adc-attr');
      if (pairs) {
        for (const pair of pairs.split(',')) {
          const [attr, field] = pair.split('=').map((x) => x.trim());
          if (attr && field && values[field] != null) {
            el.setAttribute(attr, String(values[field]));
            touched = true;
          }
        }
      }
      if (touched) el.removeAttribute('data-adc-placeholder');
    }
  },
  // Marks a link as the current one (w--current + aria-current). Webflow's own page-ready routine also
  // manages these classes — it marks any link whose path equals the page's path (e.g. "/artworks")
  // and clears the rest — and it runs at window load, which can land AFTER we render. So every state
  // set here is remembered and re-applied once the page has loaded (see reapplyCurrent).
  _currentState: new Map(),
  setCurrent(el, current) {
    window.ADC._currentState.set(el, !!current);
    el.classList.toggle('w--current', !!current);
    if (current) el.setAttribute('aria-current', 'page');
    else el.removeAttribute('aria-current');
  },
  reapplyCurrent() {
    for (const [el, current] of window.ADC._currentState) {
      el.classList.toggle('w--current', current);
      if (current) el.setAttribute('aria-current', 'page');
      else el.removeAttribute('aria-current');
    }
  },
  // items: [{values: {field: value}, current?: boolean}]. Returns the new elements.
  render(mount, items) {
    const sample = mount.querySelector('[data-adc-template]');
    if (!sample) {
      console.error('[adc] no sample item (an element with data-adc-template) inside', mount);
      return [];
    }
    const made = items.map((item) => {
      const node = sample.cloneNode(true);
      node.removeAttribute('data-adc-template');
      window.ADC.fill(node, item.values);
      for (const el of [node, ...node.querySelectorAll('[data-adc-current]')]) {
        if (el.hasAttribute('data-adc-current')) window.ADC.setCurrent(el, item.current);
      }
      sample.before(node);
      return node;
    });
    sample.remove();
    return made;
  },
  // Webflow binds its interactions (animations) to the elements that exist when the page loads, so
  // items created afterwards would not animate. Re-running its init picks them up. It must NOT run
  // while Webflow is still starting up: calling ix2.init() during that window overflows Webflow's own
  // stack ("Maximum call stack size exceeded"), which showed up as soon as real animations existed.
  // So it waits for the page's load event plus a short beat; nothing waits on it.
  refreshInteractions() {
    const run = () => {
      setTimeout(window.ADC.reapplyCurrent, 0); // Webflow's load-time link routine has run by now
      setTimeout(() => {
        try {
          const ix2 = window.Webflow && window.Webflow.require && window.Webflow.require('ix2');
          if (ix2 && typeof ix2.init === 'function') ix2.init();
        } catch (e) {
          console.warn('[adc] could not refresh Webflow interactions', e);
        }
        window.ADC.reapplyCurrent();
      }, 300);
    };
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  },
  // Flag name -> version (e.g. the sale id). See "Conditional components" above.
  flags: new Map(),
  setFlag(name, on, version = '') {
    if (on) window.ADC.flags.set(name, String(version));
    else window.ADC.flags.delete(name);
  },
  // Shows/hides every data-adc-show / data-adc-hide element for the current flags. Cheap; call it after
  // changing flags and after new elements have been rendered (ADC_READY does).
  applyFlags() {
    const { flags } = window.ADC;
    const dismissed = readDismissed();
    const names = (el, attr) => (el.getAttribute(attr) || '').split(/\s+/).filter(Boolean);
    document.documentElement.setAttribute('data-adc-flags', [...flags.keys()].join(' '));
    for (const el of document.querySelectorAll('[data-adc-show]')) {
      const on = names(el, 'data-adc-show').filter((f) => flags.has(f));
      const visible = on.length > 0 && !on.some((f) => dismissed.has(`${f}@${flags.get(f)}`));
      el.toggleAttribute('data-adc-visible', visible);
    }
    for (const el of document.querySelectorAll('[data-adc-hide]')) {
      el.toggleAttribute('data-adc-hidden', names(el, 'data-adc-hide').some((f) => flags.has(f)));
    }
    document.dispatchEvent(new CustomEvent('adc-flags-change'));
  },
  // Renderers register their work here so ADC_READY knows when the page content exists.
  // A failing renderer is logged and resolves null instead of breaking the page.
  _pending: [],
  track(promise) {
    const safe = promise.catch((e) => {
      console.error('[adc] renderer failed', e);
      return null;
    });
    window.ADC._pending.push(safe);
    return safe;
  },
  // Inline style every option radio carries in the Designer embeds (invisible hit area).
  RADIO_STYLE: 'opacity:0; position:absolute; inset:0; width:100%; height:100%; z-index:10; cursor:pointer; margin:0;',
};

// Resolves once the DOM is parsed AND every tracked renderer has finished (or failed).
// art-engine's own scripts wait on this (when present) instead of bare DOMContentLoaded,
// so they initialize against the real option radios rather than empty containers.
// The setTimeout lets every script loaded after this one (in the same bundle or later tags) register its
// renders first. If the DOM is already parsed (a script loaded late), it starts right away instead of
// waiting for a DOMContentLoaded that has already happened.
window.ADC_READY = new Promise((resolve) => {
  const start = () => {
    setTimeout(async () => {
      await Promise.allSettled(window.ADC._pending);
      window.ADC.applyFlags(); // also covers items the renderers just cloned
      window.ADC.refreshInteractions();
      resolve();
    }, 0);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
});

// A close button inside a conditional component (data-adc-dismiss): hide it and remember that for the
// flags it is showing for, at their current version.
document.addEventListener('click', (e) => {
  const btn = e.target.closest && e.target.closest('[data-adc-dismiss]');
  const box = btn && btn.closest('[data-adc-show]');
  if (!box) return;
  e.preventDefault();
  const dismissed = readDismissed();
  for (const f of (box.getAttribute('data-adc-show') || '').split(/\s+/)) {
    if (window.ADC.flags.has(f)) dismissed.add(`${f}@${window.ADC.flags.get(f)}`);
  }
  try {
    localStorage.setItem(DISMISS_KEY, JSON.stringify([...dismissed].slice(-50)));
  } catch {
    // storage blocked: it just closes for this page view
  }
  box.removeAttribute('data-adc-visible');
});

  })(); } catch (e) { console.error('[adc] storefront-core.js failed', e); }

  /* ===== JS/storefront-artwork-detail.js (product pages only) ===== */
  if (isProductPage) try { (function () {
// Loads the artwork this product page is showing and binds it into the page.
// Replaces the CMS fields on the old /artwork/<slug> collection template page.
//
// Which artwork: the `id` query parameter, e.g. /artwork-detail?id=<artworks.id>. Read from the
// store's published snapshot (artwork/<id>.json); an artwork added or edited since the last
// Publish isn't there yet (or still shows its old data).
// (artworks has no slug column yet — switching to readable URLs is a pending decision,
// see PROJECT_TRACKER.md "Static pages vs. CMS template pages".)
//
// What it fills (all optional; the elements live in the Webflow Designer and are marked with the
// data-adc-* attributes described in storefront-core.js). Fields offered: title, name (= title),
// image (the 1440w artwork image; also the Foxy cart image), plus whatever else a page element asks for:
//   [data-adc-bind="title"]                        text = artwork title
//   img[data-adc-src="image"][data-adc-alt="title"] the artwork image
//   inputs with data-adc-attr="value=title|image"  the hidden Foxy cart fields (name/image)
// Elements marked data-adc-placeholder show sample content in the Designer only; they are hidden on
// the published page until this fills them.
//
// Other scripts await window.ADC_ARTWORK (resolves to the artwork's snapshot document — id, title,
// description, images, size_ids — or null).

window.ADC_ARTWORK = window.ADC.track((async function loadArtwork() {
  const id = new URLSearchParams(window.location.search).get('id');
  if (!id) {
    console.warn('[adc-artwork] no ?id= in the URL — nothing to show.');
    return null;
  }

  if (!/^[0-9a-f-]{36}$/i.test(id)) {
    console.error(`[adc-artwork] "${id}" is not an artwork id`);
    return null;
  }

  let art = null;
  try {
    art = await window.ADC.file(`artwork/${id}.json`);
  } catch (e) {
    console.error(`[adc-artwork] artwork ${id} is not in the published snapshot (${e.message})`);
  }
  if (!art) return null;

  // The preview shows the 1440w file (382KB vs 753KB for 2160w). Its long edge is already >= the
  // preview's on-screen long edge x DPR 2 on any normal screen (box is capped at 70vh), and the file's
  // pixel size is also what sizes the preview's layout, so don't go much smaller (see CLAUDE.md).
  // JS/storefront-preload.js preloads the same file: keep the two in step.
  const image = art.image_1440w_url || art.image_2160w_url || art.image_720w_url || '';
  // The hidden Foxy cart `image` field gets this same file (fill() below): the cart thumbnail then
  // reuses the preview download instead of fetching a separate 753KB 2160w. Nothing downstream needs
  // the full-size file there; order fulfilment reads the original from R2.
  const title = art.title || '';

  document.title = title ? `${title} Print | Art DeCoeur` : document.title;

  // The preview's width comes from this image, so a lazy image in a zero-width container can
  // never be judged "near the viewport" and never loads (seen at tablet width). Load it now.
  const previews = [...document.querySelectorAll('img[data-adc-placeholder][data-adc-src="image"]')];
  previews.forEach((img) => {
    img.loading = 'eager';
  });
  window.ADC.fill(document.body, { title, image });

  // fill() un-hides the preview straight away (it drops data-adc-placeholder), but the real image
  // (~550KB) is still downloading, and Safari/Firefox keep painting the previous image until the
  // new one arrives — here, the Designer's sample artwork, i.e. a different picture. Keep the
  // preview hidden until the real one has loaded. Measured: no added delay (load event, `complete`
  // and the reveal land on the same millisecond).
  previews.forEach((img) => {
    const showingArtwork = img.complete && img.naturalWidth > 0 && img.currentSrc === image;
    if (showingArtwork) return;
    img.style.visibility = 'hidden';
    img.addEventListener('load', () => img.style.removeProperty('visibility'), { once: true });
    img.addEventListener('error', () => console.error(`[adc-artwork] preview image failed to load: ${image}`), { once: true });
  });

  return art;
})());

  })(); } catch (e) { console.error('[adc] storefront-artwork-detail.js failed', e); }

  /* ===== JS/storefront-artwork-list.js ===== */
  try { (function () {
// The all-artworks listing page: a category sidebar and a grid of artwork cards, replacing the
// CMS-bound "Primary Categories" template. Reads the store's published snapshot
// (categories.json + artworks.json). Markup is copied from that template's published output.
//
// Which category: the `category` query parameter, e.g. /artworks?category=wildlife or
// ?category=bison (a category's slug is its name, lowercased, punctuation dropped). No parameter
// means every artwork. A primary category shows everything tagged with it or any of its children.
//
// The design lives in the Webflow Designer; this script only supplies data. Each mount holds a
// SAMPLE item (an element marked data-adc-template) that is cloned once per row — see
// ADC.render() in storefront-core.js for the fields a sample can bind (data-adc-bind/-href/-src/-alt,
// data-adc-current). Nothing here builds markup.
//
// Mounts (all optional; give each the list class the Designer list had):
//   [data-adc-mount="artworks-categories"]     primary categories   Collection List 6
//       sample: the link to repeat (fields: name, url).  A static link marked data-adc-all (the
//       "All" link) is kept as is and gets the current state when no category is chosen.
//   [data-adc-mount="artworks-subcategories"]  the chosen primary's subcategories   Collection List 3
//       sample fields: name, url
//   [data-adc-mount="artworks-grid"]           artwork cards        CategoriesCollection
//       sample fields: url (link), image + title (img src/alt)
//   [data-adc-bind="category-title"]           text = chosen category name (or "All Artworks")
// The grid mount can set data-adc-product-url (default /artwork-detail) for where cards link; the
// artwork is passed as ?id=<artworks.id>.
//
// Categories with no artworks are not listed (the old CMS listed them all, empty or not).

window.ADC.track((async function loadArtworksListing() {
  const mounts = {
    categories: document.querySelector('[data-adc-mount="artworks-categories"]'),
    subcategories: document.querySelector('[data-adc-mount="artworks-subcategories"]'),
    grid: document.querySelector('[data-adc-mount="artworks-grid"]'),
  };
  if (!Object.values(mounts).some(Boolean)) return;

  const [categoryFile, artworkFile] = await Promise.all([
    window.ADC.file('categories.json'),
    window.ADC.file('artworks.json'),
  ]);
  if (!categoryFile || !artworkFile) return;

  // Order as the dashboard's sidebar does: sort_order, empty ones last. (The snapshot lists
  // categories grouped by main_category; artworks arrive already in manual_sort / newest order.)
  const categories = [...categoryFile.categories].sort(
    (a, b) => (a.sort_order ?? Infinity) - (b.sort_order ?? Infinity) || a.id.localeCompare(b.id),
  );
  const artworks = artworkFile.artworks.filter((a) => a.image_720w_url);

  // Each category has its OWN order, arranged by the owner in the dashboard: {categoryId: [artworkIds]}.
  // The unfiltered page keeps the overall ("All media") order. An older snapshot without this map
  // simply falls back to the overall order everywhere.
  const categoryOrders = artworkFile.category_orders || {};
  const inCategoryOrder = (list, cat) => {
    const ids = categoryOrders[cat.id];
    if (!ids) return list;
    const rank = new Map(ids.map((id, i) => [id, i]));
    return [...list].sort((a, b) => (rank.get(a.id) ?? Infinity) - (rank.get(b.id) ?? Infinity));
  };

  const slugify = window.ADC.slugify;

  const primaries = categories.filter((c) => !c.main_category);
  const childrenOf = (primary) => categories.filter((c) => c.main_category === primary.sub_category);
  const primaryOf = (c) => (c.main_category ? primaries.find((p) => p.sub_category === c.main_category) : c);

  // ids of the categories whose artworks belong to a category (itself, plus children for a primary)
  const scopeIds = (c) =>
    new Set(c.main_category ? [c.id] : [c.id, ...childrenOf(c).map((child) => child.id)]);

  const tagged = artworks.map((a) => ({ art: a, ids: new Set(a.category_ids) }));
  const artworksIn = (c) => {
    const scope = scopeIds(c);
    return tagged.filter((t) => [...scope].some((id) => t.ids.has(id))).map((t) => t.art);
  };
  const countOf = (c) => artworksIn(c).length;

  const wanted = new URLSearchParams(window.location.search).get('category');
  const selected = wanted ? categories.find((c) => slugify(c.sub_category) === wanted) : null;
  const activePrimary = selected ? primaryOf(selected) : null;
  const base = window.location.pathname;
  const link = (c) => `${base}?category=${slugify(c.sub_category)}`;

  if (mounts.categories) {
    const all = mounts.categories.querySelector('[data-adc-all]');
    if (all) window.ADC.setCurrent(all, !selected);
    window.ADC.render(
      mounts.categories,
      primaries
        .filter((p) => countOf(p) > 0)
        .map((p) => ({
          values: { name: p.sub_category, url: link(p) },
          current: !!(selected && activePrimary && p.id === activePrimary.id && !selected.main_category),
        })),
    );
  }

  if (mounts.subcategories) {
    window.ADC.render(
      mounts.subcategories,
      activePrimary
        ? childrenOf(activePrimary)
            .filter((c) => countOf(c) > 0)
            .map((c) => ({
              values: { name: c.sub_category, url: link(c) },
              current: !!(selected && c.id === selected.id),
            }))
        : [],
    );
  }

  const title = selected ? selected.sub_category : 'All Artworks';
  document.querySelectorAll('[data-adc-bind="category-title"]').forEach((el) => {
    el.textContent = title;
  });

  if (mounts.grid) {
    const productUrl = mounts.grid.getAttribute('data-adc-product-url') || '/artwork-detail';
    const visible = selected ? inCategoryOrder(artworksIn(selected), selected) : artworks;
    window.ADC.render(
      mounts.grid,
      visible.map((a) => ({
        values: { url: `${productUrl}?id=${a.id}`, image: a.image_720w_url, title: a.title || '' },
      })),
    );
  }
})());

  })(); } catch (e) { console.error('[adc] storefront-artwork-list.js failed', e); }

  /* ===== JS/storefront-home-categories.js ===== */
  try { (function () {
// The homepage category grid: one card per PRIMARY category that has artworks (empty categories are
// not shown), replacing the CMS-bound collection list. The card is a SAMPLE built in the Webflow
// Designer (see ADC.render in storefront-core.js); this script only supplies the values.
//
// Mount: [data-adc-mount="home-categories"] holding one sample card marked data-adc-template.
// Sample fields: name (text + image alt), url (card link), image (img src).
//
// Which thumbnail: the artwork the owner starred for the category in the dashboard
// (categories.thumbnail_artwork_id) — if that artwork is still in the category and published.
// Otherwise the category's first artwork (in the order arranged in the dashboard) that no other card is already showing
// (categories overlap heavily, so plain "first artwork" repeats the same image), so a card is never
// blank and the grid doesn't look repetitive. Chosen thumbnails are honoured first.
// Order: the dashboard's category order (sort_order). Links go to /artworks?category=<slug>.

window.ADC.track((async function loadHomeCategories() {
  const mount = document.querySelector('[data-adc-mount="home-categories"]');
  if (!mount) return;

  const [categoryFile, artworkFile] = await Promise.all([
    window.ADC.file('categories.json'),
    window.ADC.file('artworks.json'),
  ]);
  if (!categoryFile || !artworkFile) return;

  const artworks = artworkFile.artworks.filter((a) => a.image_720w_url);
  const byId = new Map(artworks.map((a) => [a.id, a]));
  const categoryOrders = artworkFile.category_orders || {};
  // a category's artworks in the order the owner arranged them there (overall order if not available)
  const inCategory = (cat) => {
    const list = artworks.filter((a) => a.category_ids.includes(cat.id));
    const ids = categoryOrders[cat.id];
    if (!ids) return list;
    const rank = new Map(ids.map((id, i) => [id, i]));
    return list.sort((a, b) => (rank.get(a.id) ?? Infinity) - (rank.get(b.id) ?? Infinity));
  };

  const primaries = categoryFile.categories
    .filter((c) => !c.main_category && c.artwork_count > 0)
    .sort((a, b) => (a.sort_order ?? Infinity) - (b.sort_order ?? Infinity) || a.id.localeCompare(b.id));

  // 1) explicit picks (kept only while the artwork is still in the category and published)
  const used = new Set();
  const chosen = new Map();
  for (const cat of primaries) {
    const picked = cat.thumbnail_artwork_id ? byId.get(cat.thumbnail_artwork_id) : null;
    if (picked && picked.category_ids.includes(cat.id)) {
      chosen.set(cat.id, picked);
      used.add(picked.id);
    }
  }
  // 2) automatic: first artwork in the category not already used, else simply its first
  for (const cat of primaries) {
    if (chosen.has(cat.id)) continue;
    const candidates = inCategory(cat);
    const thumb = candidates.find((a) => !used.has(a.id)) || candidates[0];
    if (thumb) {
      chosen.set(cat.id, thumb);
      used.add(thumb.id);
    }
  }

  const rows = primaries
    .filter((cat) => chosen.has(cat.id)) // nothing publishable in it yet -> no card
    .map((cat) => ({
      values: {
        name: cat.sub_category,
        url: `/artworks?category=${window.ADC.slugify(cat.sub_category)}`,
        image: chosen.get(cat.id).image_720w_url,
      },
    }));

  window.ADC.render(mount, rows);
})());

  })(); } catch (e) { console.error('[adc] storefront-home-categories.js failed', e); }

  /* ===== JS/storefront-substrates.js ===== */
  try { (function () {
// Fills the Substrate, Finish and Canvas Format pickers from the published snapshot's
// substrate_options (catalog.json). The items are SAMPLES built in the Webflow Designer (see
// ADC.render in storefront-core.js); this script only supplies the values each clone is filled with.
//
// Mounts (each optional; each holds one sample item, marked data-adc-template):
//   [data-adc-mount="substrate"]      Paper / Canvas / Metal      fields: name, image, id, value, adjMult, baseKey, basePriority, slug
//   [data-adc-mount="finish-metal"]   Matte / Semi-Gloss / Gloss  fields: label, name, id, value, adjMult, baseKey, basePriority, parent, blur
//   [data-adc-mount="finish-paper"]   Luster Paper / Fine Art Paper (same fields as finishes)
//   [data-adc-mount="canvas-format"]  Stretched Canvas / Canvas Wrap  fields: label, id, value, adjMult, baseKey, basePriority, slug
// Only options the store has enabled are in the snapshot, so only those are shown.
//
// The page code compares substrate radio ids case-sensitively ("Canvas"/"Metal"/"Paper"),
// so substrate ids are the option NAME; finishes/formats use their slug, as before.
//
// Acrylic: exists in the data but is intentionally not rendered — art-engine has no
// acrylic styling/JS yet (see PROJECT_TRACKER.md). No mount for it exists on the page.

window.ADC.track((async function loadSubstrateOptions() {
  const mounts = {
    substrate: document.querySelector('[data-adc-mount="substrate"]'),
    'finish-metal': document.querySelector('[data-adc-mount="finish-metal"]'),
    'finish-paper': document.querySelector('[data-adc-mount="finish-paper"]'),
    'canvas-format': document.querySelector('[data-adc-mount="canvas-format"]'),
  };
  if (!Object.values(mounts).some(Boolean)) return;

  const catalog = await window.ADC.file('catalog.json');
  if (!catalog) return;

  const options = catalog.substrate_options;
  const byId = Object.fromEntries(options.map((o) => [o.id, o]));
  const parentOf = (o) => (o.parent_option_id ? byId[o.parent_option_id] : null);
  const label = (o) => o.ui_label || o.name;
  const common = (o) => ({
    adjMult: o.multiplier != null ? Number(o.multiplier) : 1,
    baseKey: o.base_price_key,
    basePriority: o.base_price_priority,
  });

  const substrateValues = (o) => ({
    ...common(o), name: o.name, image: o.image_url, id: o.name, value: `${o.name}{p+0}`, slug: o.slug,
  });
  const finishValues = (o) => ({
    ...common(o), label: label(o), name: o.name, id: o.slug, value: `${label(o)}{p+0}`,
    parent: parentOf(o)?.name, blur: o.blur != null ? `${o.blur}px` : '',
  });
  const formatValues = (o) => ({
    ...common(o), label: label(o), id: o.slug, value: `${label(o)}{p+0}`, slug: o.slug,
  });

  const render = (key, rows, toValues) => {
    if (mounts[key]) window.ADC.render(mounts[key], rows.map((o) => ({ values: toValues(o) })));
  };

  render('substrate', options.filter((o) => o.option_group === 'substrate' && o.slug !== 'acrylic'), substrateValues);
  render('finish-metal', options.filter((o) => o.option_group === 'finish' && parentOf(o)?.slug === 'metal'), finishValues);
  render('finish-paper', options.filter((o) => o.option_group === 'finish' && parentOf(o)?.slug === 'paper'), finishValues);
  render('canvas-format', options.filter((o) => o.option_group === 'canvas_format'), formatValues);
})());

  })(); } catch (e) { console.error('[adc] storefront-substrates.js failed', e); }

  /* ===== JS/storefront-frames.js ===== */
  try { (function () {
// Fills the three frame lists (one per tab) from the published snapshot (catalog.json). The items
// are SAMPLES built in the Webflow Designer (see ADC.render in storefront-core.js); this script only
// supplies the values each clone is filled with.
//
// Mounts (one per Tabs pane, each holding one sample item marked data-adc-template):
//   [data-adc-mount="frames-standard"]
//   [data-adc-mount="frames-floater"]
//   [data-adc-mount="frames-shadowbox"]
// Each lists the store's enabled, active frames of that frame_type (the snapshot only holds those),
// narrowest moulding width first.
// Sample fields: name, width, thumb (image src), id, value, floaterGap, image, type, perFoot, strip.
// strip = EXPERIMENTAL (frames.strip_url, migration 53): the re-exported moulding strip the frame studio
// page draws its frame and swatch from (falls back to image for a frame that has none yet).
//
// The "No Frame" radio (#none) is a static Designer element, not rendered here.
//
// KNOWN: frames.display_name is NULL for all rows — the frame code IS the customer-facing
// name (confirmed by the owner), so the code is used for labels.

window.ADC.track((async function loadFrames() {
  const mounts = {
    standard: document.querySelector('[data-adc-mount="frames-standard"]'),
    floater: document.querySelector('[data-adc-mount="frames-floater"]'),
    shadowbox: document.querySelector('[data-adc-mount="frames-shadowbox"]'),
  };
  if (!Object.values(mounts).some(Boolean)) return;

  const catalog = await window.ADC.file('catalog.json');
  if (!catalog) return;

  for (const [type, mount] of Object.entries(mounts)) {
    if (!mount) continue;
    window.ADC.render(
      mount,
      catalog.frames
        .filter((f) => f.frame_type === type)
        // Narrowest moulding first; equal widths keep the snapshot's order (by frame code).
        .sort((a, b) => (a.moulding_width_in ?? 0) - (b.moulding_width_in ?? 0))
        .map((f) => {
          const name = f.display_name || f.frame_code;
          return {
            values: {
              name,
              width: f.moulding_width_in ?? 0,
              thumb: f.thumbnail_url || f.image_url,
              id: f.frame_code,
              value: `${name}{p+0}`,
              floaterGap: type === 'floater' ? 1 : 0,
              image: f.image_url,
              type,
              perFoot: f.retail_price_per_ft ?? 0,
              strip: f.strip_url || f.image_url || '',
            },
          };
        }),
    );
  }
})());

  })(); } catch (e) { console.error('[adc] storefront-frames.js failed', e); }

  /* ===== JS/storefront-sizes.js ===== */
  try { (function () {
// Fills the Size picker from the published snapshot: only the sizes that fit THIS artwork's
// ratio, that the store has enabled, minus any the artwork excludes (the snapshot builder does
// all three — each artwork file lists its size_ids). The item is a SAMPLE built in the Webflow
// Designer (see ADC.render in storefront-core.js); this script only supplies the values.
//
// Mount: [data-adc-mount="sizes"] — give it the list class the Designer list had (Config4x1) and one
// sample item marked data-adc-template.
// Sample fields: label, id, value, area, height, perimeter, width, price_<substrate> (one per
// substrate: canvas, canvas_wrap, fine_art_paper, luster, metal, acrylic_18, acrylic_14).
//
// PRICING: catalog.json's sizes carry final prices per substrate with the dashboard's markup for
// this store ALREADY applied (price = base * (1 + markup_percent / 100)). pricing-calc.js must
// therefore add NO markup of its own (MARKUP_PERCENT = 0 on this branch; main still has 200 for
// the still-CMS-bound live page). Never mix the two.

window.ADC.track((async function loadSizes() {
  const mount = document.querySelector('[data-adc-mount="sizes"]');
  if (!mount) return;

  const [catalog, artwork] = await Promise.all([window.ADC.file('catalog.json'), window.ADC_ARTWORK]);
  if (!catalog || !artwork) return;

  const byId = new Map(catalog.sizes.map((size) => [size.id, size]));
  const sizes = artwork.size_ids.map((id) => byId.get(id)).filter(Boolean);

  window.ADC.render(
    mount,
    sizes.map((size) => {
      const values = {
        label: size.size_label,
        id: size.size_label,
        value: `${size.size_label}{p+0}`,
        area: size.area,
        height: size.height,
        perimeter: size.perimeter,
        width: size.width,
      };
      for (const [key, price] of Object.entries(size.prices)) values[`price_${key}`] = price;
      return { values };
    }),
  );
})());

  })(); } catch (e) { console.error('[adc] storefront-sizes.js failed', e); }

  /* ===== JS/storefront-sale.js ===== */
  try { (function () {
// Sales: which sale is running right now, and everything on the page that depends on it.
// Load AFTER storefront-core.js, on every page that should know about sales (any page with a sale
// banner, and the product page so prices are reduced).
//
// Data: the store's published latest.json carries `sales` (current + upcoming, written by the
// dashboard's Publish; adc-platform "Sales"): [{id, percent_off, starts_at, ends_at, components,
// headline, message}]. The running one is picked here with the visitor's clock, so a scheduled sale
// starts and ends on time with no new Publish. The dashboard never lets two sales overlap.
//
// What it drives:
//   flags (see "Conditional components" in storefront-core.js):
//     sale                 a sale is running           e.g. the crossed-out price: data-adc-show="sale"
//     sale:<component>     ...and that component is switched on in the dashboard for it:
//                          sale:top-bar, sale:banner, sale:popup, sale:badge
//   text, on any element (also inside rendered cards):
//     data-adc-sale-text="headline"   the dashboard headline (default "25% off everything")
//     data-adc-sale-text="message"    the optional extra line (element hidden when empty)
//     data-adc-sale-text="percent"    "25%"
//     data-adc-sale-text="ends"       "Nov 30" (element hidden when the sale has no end date)
//   prices: window.ADC.sale = {id, percent_off, factor, ...} or null. pricing-calc.js reduces every
//   price by `factor` and fills data-adc-price="original" / "savings". The event `adc-sale-change`
//   fires whenever the running sale changes (including while the page is open).

(function () {
  const ADC = window.ADC;
  if (!ADC) {
    console.error('[adc-sale] load storefront-core.js before storefront-sale.js');
    return;
  }
  ADC.sale = null;
  let sales = [];
  let timer = null;

  const fmtEnds = (iso) => new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  const fmtPercent = (p) => `${Number(p)}%`;

  function running(now) {
    return sales.find((s) =>
      Date.parse(s.starts_at) <= now && (!s.ends_at || now < Date.parse(s.ends_at))) || null;
  }

  function fillText(sale) {
    const values = sale
      ? {
        headline: sale.headline || `${fmtPercent(sale.percent_off)} off everything`,
        message: sale.message || '',
        percent: fmtPercent(sale.percent_off),
        ends: sale.ends_at ? fmtEnds(sale.ends_at) : '',
      }
      : {};
    for (const el of document.querySelectorAll('[data-adc-sale-text]')) {
      const value = values[el.getAttribute('data-adc-sale-text')];
      if (value == null) continue;
      el.textContent = value;
      // An optional line with nothing to say shouldn't leave an empty gap.
      if (value === '') el.style.display = 'none';
      else if (el.style.display === 'none') el.style.removeProperty('display');
    }
  }

  function apply() {
    const now = Date.now();
    const sale = running(now);
    const prevId = ADC.sale && ADC.sale.id;
    ADC.sale = sale ? { ...sale, factor: 1 - Number(sale.percent_off) / 100 } : null;

    for (const name of [...ADC.flags.keys()]) if (name === 'sale' || name.startsWith('sale:')) ADC.setFlag(name, false);
    if (sale) {
      ADC.setFlag('sale', true, sale.id);
      for (const c of sale.components || []) ADC.setFlag(`sale:${c}`, true, sale.id);
    }
    fillText(sale);
    ADC.applyFlags();
    if ((sale && sale.id) !== prevId) document.dispatchEvent(new CustomEvent('adc-sale-change', { detail: ADC.sale }));

    // Re-check at the next start/end that happens while the page is open (within a day).
    clearTimeout(timer);
    const next = sales
      .flatMap((s) => [Date.parse(s.starts_at), s.ends_at ? Date.parse(s.ends_at) : NaN])
      .filter((t) => t > now)
      .sort((a, b) => a - b)[0];
    if (next && next - now < 864e5) timer = setTimeout(apply, next - now + 50);
  }

  const domReady = new Promise((resolve) => {
    if (document.readyState !== 'loading') resolve();
    else document.addEventListener('DOMContentLoaded', resolve, { once: true });
  });

  // Tracked, so ADC_READY (and pricing-calc.js behind it) waits until ADC.sale is known.
  ADC.track((async () => {
    const latest = await ADC.latest;
    sales = Array.isArray(latest && latest.sales) ? latest.sales : [];
    await domReady;
    apply();
  })());
  // Rendered items (artwork cards with a sale badge) exist only after ADC_READY: fill their text too.
  if (window.ADC_READY) window.ADC_READY.then(() => fillText(ADC.sale));
})();

  })(); } catch (e) { console.error('[adc] storefront-sale.js failed', e); }

  /* ===== JS/frame-substrate-var-updates.js (product pages only) ===== */
  if (isProductPage) try { (function () {
// Waits for storefront-*.js content when present (ADC_READY); otherwise plain DOMContentLoaded.
(window.ADC_READY ? (fn) => window.ADC_READY.then(() => fn()) : (fn) => document.addEventListener('DOMContentLoaded', fn))(() => {
    const root = document.documentElement;

    // --- helpers ----------------------------------------------------
    function getSelectedEl(kind) {
      // 1) native radio
      let el = document.querySelector(`input[type="radio"][data-option-type="${kind}"]:checked`);
      if (el) return el;

      // 2) ARIA / custom wrapper
      el = document.querySelector(`[data-option-type="${kind}"][aria-checked="true"]`);
      if (el) return el;

      // 3) Webflow redirected radios
      el = document.querySelector(`input[type="radio"][data-option-type="${kind}"].w--redirected-checked`);
      return el || null;
    }

    function readData(el, key) {
      if (!el) return undefined;
      if (el.dataset && el.dataset[key] !== undefined) return el.dataset[key];
      const inner = el.querySelector?.('input[type="radio"]');
      return inner?.dataset?.[key];
    }

    // --- frame image warm/preload -------------------------------------
    // Frame moulding images are small JPEGs (8-80KB each, from r2.dev), so the
    // visible delay on first pick is mostly round-trip latency. Writing
    // --frame-image the instant a radio changes leaves the old frame gone
    // and nothing painted until the new file fetches+decodes — the "gray
    // hole" bug. Instead we preload the target and only commit the var once
    // it's ready, toggling [data-frame-loading] on <html> in the meantime so
    // CSS can fade the existing frame down rather than showing a blank gap
    // (see the rule in CSS/frame-rendering.css).
    const frameImageCache = new Set(); // urls confirmed loaded at least once this session
    let frameImageToken = 0;
    let currentFrameImageUrl = null; // last url requested/applied, loaded or not

    function applyFrameImage(url) {
      url = url || '';
      // applyVars() re-runs for reasons that have nothing to do with the frame
      // (another radio, a third-party mutation) while this one may still be
      // mid-load — without this guard each re-run would spin up a redundant
      // Image() and invalidate the in-flight request's token below.
      if (url === currentFrameImageUrl) return;
      currentFrameImageUrl = url;

      const token = ++frameImageToken; // invalidates any still-loading older pick

      if (!url) {
        root.style.setProperty('--frame-image', 'none');
        root.style.setProperty('--f-on-off-pre', '0');
        root.removeAttribute('data-frame-loading');
        return;
      }

      root.style.setProperty('--f-on-off-pre', '1');

      if (frameImageCache.has(url)) {
        root.style.setProperty('--frame-image', `url(${url})`);
        root.removeAttribute('data-frame-loading');
        return;
      }

      root.setAttribute('data-frame-loading', '1');

      const img = new Image();
      img.onload = () => {
        frameImageCache.add(url);
        if (token !== frameImageToken) return; // superseded by a later pick
        root.style.setProperty('--frame-image', `url(${url})`);
        root.removeAttribute('data-frame-loading');
      };
      img.onerror = () => {
        if (token !== frameImageToken) return;
        root.removeAttribute('data-frame-loading');
      };
      img.src = url;
    }

    // Deliberately NO hover/focus warming of frame images or substrate textures. A pointer handler
    // runs on every element the mouse crosses, which competes with the mouse-driven lighting
    // animation. Both are loaded on click instead:
    //  - frames: the click runs applyFrameImage() above (preload + fade via data-frame-loading);
    //  - substrate textures: the click sets data-substrate on <html> (updateSubstrateFlags), which
    //    un-hides that substrate's layers in CSS/substrates.css, and the browser fetches their
    //    textures then. Nothing is prefetched on load, so a visitor only downloads the textures
    //    for the substrate they actually pick.

    // --- update blocks (add more of these as needed) ----------------

    function updateFrameVars() {
      const frameEl = getSelectedEl('frame');
      const sizeEl = getSelectedEl('size');

      // If no frame OR no size → reset everything and exit
      if (!frameEl || !sizeEl) {
        applyFrameImage('');
        root.style.setProperty('--f-pre-width', '0%');
        root.style.setProperty('--floater-gap-pre', '0%');
        root.style.setProperty('--floater-parallax-offset', '1'); // Reset to '1' (off)
        return;
      }

      // 1) frame image + on/off -----------------------------------------
      const url = readData(frameEl, 'frameImage') || '';
      applyFrameImage(url);

      const fwRaw = readData(frameEl, 'fWidth');
      const swRaw = readData(sizeEl, 'sWidth');
      const gapFlag = readData(frameEl, 'floaterGap');

      const hasFrame = fwRaw && fwRaw !== 'none';
      const fw = hasFrame ? parseFloat(fwRaw) : 0;
      const sw = swRaw ? parseFloat(swRaw) : NaN;

      // 2) --f-pre-width -----------------------------------------
      if (hasFrame && isFinite(fw) && isFinite(sw)) {
        const pre = (fw / (fw * 2 + sw)) * 100;
        root.style.setProperty('--f-pre-width', `${pre.toFixed(3)}%`);
      } else {
        root.style.setProperty('--f-pre-width', '0%');
      }

      // 3) --floater-gap-pre -----------------------------------------
      if (hasFrame && gapFlag === '1' && isFinite(fw) && isFinite(sw)) {
        const gap = 25 / (sw + (fw * 2 + 0.5));
        root.style.setProperty('--floater-gap-pre', `${gap.toFixed(3)}%`);
      } else {
        root.style.setProperty('--floater-gap-pre', '0%');
      }

      // 4) --floater-parallax-offset --------------------------------------
      // Sets variable to '-1' if the gap flag is actively on, otherwise '1'
      root.style.setProperty('--floater-parallax-offset', gapFlag === '1' ? '-1' : '1');
      root.style.setProperty('--floater-gap-inactive', gapFlag === '1' ? '0' : '1');
    }

    // Checked radio for a group, native or Webflow-redirected.
    function getChecked(name) {
      return (
        document.querySelector(`input[name="${name}"]:checked`) ||
        document.querySelector(`input[name="${name}"].w--redirected-checked`)
      );
    }

    // Option-group "chosen" state, for anything that isn't near the radios.
    //
    // Tag an element with data-option-group="<radio group name>" and it gets the
    // `active` class whenever that group has a selection. `.text-block-14.active`
    // is already a real combo class in the Designer (moss green), so the look
    // stays editable in the Webflow UI — nothing about the styling lives here.
    //
    // A pure-CSS :has() rule would work too, but the summary bar and the radios
    // only share <body>, so the selector would have to hang off <body> and could
    // not be authored in the Designer. Toggling a class is what buys UI control.
    function updateOptionGroupStates() {
      document.querySelectorAll('[data-option-group]').forEach(el => {
        el.classList.toggle('active', !!getChecked(el.dataset.optionGroup));
      });
    }

    // Substrate flags — one query for all three (was two queries each, x3).
    function updateSubstrateFlags() {
      const el = getChecked('substrate');
      const id = el ? el.id : '';

      const isCanvas = id === 'Canvas';
      const isMetal = id === 'Metal';
      const isPaper = id === 'Paper';

      root.style.setProperty('--sub-canvas', isCanvas ? '1' : '0');
      root.style.setProperty('--sub-metal', isMetal ? '1' : '0');
      root.style.setProperty('--sub-paper', isPaper ? '1' : '0');

      // Mirrored onto an attribute because CSS can't branch on a numeric custom
      // property, and the inactive substrates' blend/filter layers need to be
      // display:none rather than opacity:0 to actually free memory in Safari.
      // See the gating block in CSS/substrates.css.
      root.setAttribute(
        'data-substrate',
        isCanvas ? 'canvas' : isMetal ? 'metal' : isPaper ? 'paper' : 'none',
      );

      return { isCanvas, isMetal, isPaper };
    }

    // Canvas format flags (gallery wrap + loose canvas) — one query for both.
    function updateCanvasFormatFlags() {
      const el = getChecked('canvas-format');
      const id = el ? el.id : '';

      const isGalleryWrap = id === 'gallery-wrap';
      const isLooseCanvas = id === 'loose-canvas';

      root.style.setProperty('--c-wrap', isGalleryWrap ? '1' : '0');
      root.style.setProperty('--loose-canvas', isLooseCanvas ? '1' : '0');
      root.setAttribute('data-c-wrap', isGalleryWrap ? '1' : '0');

      return { isGalleryWrap, isLooseCanvas };
    }

    function updateShadowboxFlag() {
      const selectedFrame = getChecked('frame');

      const isShadowbox = selectedFrame && selectedFrame.dataset.frameType === 'shadowbox';

      root.style.setProperty('--s-box', isShadowbox ? '1' : '0');
    }

    // Grabs the active 'finish' radio button (native or Webflow custom).
    // Reads its 'data-substrate-blur' attribute and updates the
    // '--substrate-blur' CSS variable on the document root. Defaults to '0'.
    function updateSubstrateBlur() {
      const selectedFinish = document.querySelector('input[name="finish"]:checked') || document.querySelector('input[name="finish"].w--redirected-checked');

      // dataset maps 'data-substrate-blur' to 'substrateBlur'
      const blurValue = readData(selectedFinish, 'substrateBlur');

      // Update the variable, defaulting to '0' if no value is found
      root.style.setProperty('--substrate-blur', blurValue !== undefined ? blurValue : '0');
    }

    // Size area → canvas background scale
    // Reads the selected Size's data-area and converts it to CSS variables
    function updateSizeAreaVars() {
      const sizeEl = getSelectedEl('size');
      if (!sizeEl) return;

      // 1) Background Scale (Area) Calculation
      const areaRaw = readData(sizeEl, 'area');
      if (areaRaw) {
        const area = parseFloat(areaRaw);
        if (isFinite(area) && area > 0) {
          const side = Math.sqrt(area);
          const base = 100;
          const scale = base / side;
          root.style.setProperty('--size-area', `${scale}%`);
        }
      }

      // 2) One Inch Calculation
      // Reads the width of the size and calculates 1 inch as a percentage
      const swRaw = readData(sizeEl, 'sWidth');
      if (swRaw) {
        const sw = parseFloat(swRaw);
        if (isFinite(sw) && sw > 0) {
          root.style.setProperty('--one-inch', `${(100 / sw).toFixed(3)}%`);
        } else {
          root.style.setProperty('--one-inch', '0%');
        }
      }
    }
    // --- main aggregator --------------------------------------------

    const MO_TARGETS = { childList: true, subtree: true };
    let mo = null;

    // Watch only the option controls, never document.body.
    //
    // Measured on the live page: ~899 mutation records in 5 seconds (~180/sec)
    // with nobody touching anything. Almost none of it is ours — it's Cloudflare
    // Turnstile re-challenging, Stripe iframes, Microsoft Clarity, and a Safari
    // ad-blocker extension injecting into every frame. Observing document.body
    // turned all of that into a full visibility pass every frame, forever.
    // Coalescing to rAF capped the rate but not the work.
    //
    // Scoped here, third-party churn outside the config UI is simply not seen.
    function getObserverRoot() {
      return (
        document.querySelector('.product-options') ||
        document.querySelector('form[class*="foxy"]') ||
        document.body
      );
    }

    // Circuit breaker: if we somehow still see runaway mutation volume, stop
    // observing rather than burn a frame's budget forever. Explicit user
    // interaction still drives updates through the change/click listeners.
    const MUTATION_BUDGET = 5000;
    let mutationCount = 0;

    function applyVars() {
      // updateAllVisibility writes display/class changes, which are themselves
      // mutations. Detaching first stops the observer feeding itself — the old
      // version could re-enter through its own output.
      if (mo) mo.disconnect();

      updateFrameVars();
      const substrate = updateSubstrateFlags();
      const format = updateCanvasFormatFlags();
      updateShadowboxFlag();
      updateSizeAreaVars();
      updateSubstrateBlur();

      // Hand the flags over directly rather than making ui-visibility.js read
      // them back out of CSS with six getComputedStyle calls.
      if (window.updateAllVisibility) {
        window.updateAllVisibility({ ...substrate, ...format });
      }

      // After updateAllVisibility, not before: hiding a section clears the radios
      // inside it, so a group can go from selected to empty during that call.
      updateOptionGroupStates();

      if (mo) {
        mo.takeRecords(); // drop anything queued by our own writes
        mo.observe(getObserverRoot(), MO_TARGETS);
      }
    }

    // --- events / observers ------------------------------------------
    // Everything funnels through one rAF-coalesced entry point. A single label
    // click used to fire applyVars twice (change + click) plus however many
    // times the observer re-triggered; now it runs once per frame at most.

    let scheduled = false;
    function scheduleApply() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        applyVars();
      });
    }

    document.addEventListener(
      'change',
      (e) => {
        if (e.target.matches('input[type="radio"], [role="radio"], [data-option-type]')) {
          scheduleApply();
        }
      },
      true,
    );

    document.addEventListener(
      'click',
      (e) => {
        if (e.target.closest('label,[role="radio"],[data-option-type]')) {
          scheduleApply();
        }
      },
      true,
    );

    mo = new MutationObserver((records) => {
      mutationCount += records.length;
      if (mutationCount > MUTATION_BUDGET) {
        mo.disconnect();
        mo = null;
        return;
      }
      scheduleApply();
    });
    mo.observe(getObserverRoot(), MO_TARGETS);

    applyVars();
  });

  })(); } catch (e) { console.error('[adc] frame-substrate-var-updates.js failed', e); }

  /* ===== JS/pricing-calc.js (product pages only) ===== */
  if (isProductPage) try { (function () {
// Waits for storefront-*.js content when present (ADC_READY); otherwise plain DOMContentLoaded.
(window.ADC_READY ? (fn) => window.ADC_READY.then(() => fn()) : (fn) => document.addEventListener('DOMContentLoaded', fn))(() => {
  // The price shown is every #product-price that isn't one of the sale's extra price elements. A duplicated
  // price element in the Designer keeps the id, and getElementById would then pick whichever came first
  // (on the Art Decoeur page that was the crossed-out copy, leaving the real price at $0.00).
  const priceEls = [...document.querySelectorAll('[id="product-price"]:not([data-adc-price])')];

  // BRANCH (Supabase-fed pages): 0, because storefront-sizes.js reads prices from the
  // store_size_prices view, which already includes the store's markup. main keeps 200 for
  // the still-CMS-bound live page. Merge to main only together with the Designer cutover.
  const MARKUP_PERCENT = 0;

  function withMarkup(base) {
    return base * (1 + MARKUP_PERCENT / 100);
  }

  // SALE (storefront-sale.js): while a sale runs, window.ADC.sale.factor (e.g. 0.75 for 25% off) reduces
  // every price part, and each reduced part is rounded to cents, so the total shown is exactly what the
  // {p+N} values make Foxy charge. The full price goes to [data-adc-price="original"] (show it crossed out
  // with data-adc-show="sale") and the difference to [data-adc-price="savings"].
  function saleFactor() {
    const f = window.ADC && window.ADC.sale && window.ADC.sale.factor;
    return Number.isFinite(f) && f > 0 && f < 1 ? f : 1;
  }

  function money(n) {
    return `$${(Number.isFinite(n) ? n : 0).toFixed(2)}`;
  }

  function getSelected(name) {
    return document.querySelector(`input[type="radio"][name="${name}"]:checked`);
  }

  function getSelectedRadios() {
    return Array.from(document.querySelectorAll('input[type="radio"]:checked'));
  }

  function readNumberFromAttr(el, attr, fallback = 0) {
    if (!el) return fallback;
    const raw = el.getAttribute(attr);
    if (raw === null) return fallback;
    const n = Number(raw);
    return Number.isFinite(n) ? n : fallback;
  }

  function setPriceValue(input, amount) {
    if (!input) return;
    const val = input.value || '';
    const prefixMatch = val.match(/^([^{}]*)/);
    let prefix = prefixMatch ? prefixMatch[1] : '';
    if (!prefix) prefix = input.name || '';
    input.value = `${prefix}{p+${amount}}`;
  }

  // ----------------------------
  // Base selection (data-driven)
  // ----------------------------
  function pickBaseKey(selectedRadios) {
    let bestKey = null;
    let bestPriority = -Infinity;

    for (const el of selectedRadios) {
      const keyRaw = el.getAttribute('data-base-key');
      if (!keyRaw) continue;

      const key = keyRaw.trim().toLowerCase();
      if (!key) continue;

      const pr = readNumberFromAttr(el, 'data-base-priority', 0);
      if (pr > bestPriority) {
        bestPriority = pr;
        bestKey = key;
      }
    }

    return bestKey; // can be null
  }

  function getBasePrintPrice(sizeEl, baseKey) {
    if (!sizeEl || !baseKey) return 0;
    return readNumberFromAttr(sizeEl, `data-price-${baseKey}`, 0);
  }

  // -----------------------------------
  // Adjustments (deltas on base print)
  // -----------------------------------
  function calcAdjustmentDelta(el, basePrintPrice) {
    // multiplier delta: base * (m - 1)
    const multRaw = el.getAttribute('data-adj-mult');
    if (multRaw !== null) {
      const m = Number(multRaw);
      if (Number.isFinite(m)) {
        return basePrintPrice * (m - 1);
      }
      return 0;
    }

    // fixed add-on: +add
    const addRaw = el.getAttribute('data-adj-add');
    if (addRaw !== null) {
      const a = Number(addRaw);
      return Number.isFinite(a) ? a : 0;
    }

    return 0;
  }

  function recalc() {
    const sizeEl  = getSelected('size');
    const frameEl = getSelected('frame');

    const selected = getSelectedRadios();

    // -----------------------------
    // Base print price (baked)
    // -----------------------------
    const baseKey = pickBaseKey(selected);
    const basePrintPrice = withMarkup(getBasePrintPrice(sizeEl, baseKey));

    // -----------------------------
    // Adjustments (print only)
    // -----------------------------
    let adjustmentsTotal = 0;

    for (const el of selected) {
      // Adjustments are opt-in; ignore anything without adj attrs.
      // If you later add data-adj-target, you can filter here; for now print-only.
      if (el.hasAttribute('data-adj-mult') || el.hasAttribute('data-adj-add')) {
        adjustmentsTotal += calcAdjustmentDelta(el, basePrintPrice);
      }
    }

    // -----------------------------
    // Frame (optional, independent)
    // -----------------------------
    const perimeter = readNumberFromAttr(sizeEl, 'data-perimeter', 0);
    const ppFoot    = readNumberFromAttr(frameEl, 'data-pp-foot', 0);
    const fWidth    = readNumberFromAttr(frameEl, 'data-f-width', 0);

    const framePrice = frameEl
      ? (perimeter + 8 * fWidth) / 12 * ppFoot
      : 0;

//------------------------------------------------------------------------
//	FORMULA
//------------------------------------------------------------------------

    const factor = saleFactor();
    const onSale = (amount) => (factor === 1 ? amount : Math.round(amount * factor * 100) / 100);

    const sizePrice  = onSale(basePrintPrice);
    // Each option's delta is rounded on its own (that's what Foxy gets), so sum those, not round the sum.
    const adjPrice   = selected
      .filter((el) => el.hasAttribute('data-adj-mult') || el.hasAttribute('data-adj-add'))
      .reduce((sum, el) => sum + onSale(calcAdjustmentDelta(el, basePrintPrice)), 0);
    const frameTotal = onSale(framePrice);
    const fullPrice  = basePrintPrice + adjustmentsTotal + framePrice;

//------------------------------------------------------------------------
//	FORMULA
//------------------------------------------------------------------------

    const totalPrice = sizePrice + adjPrice + frameTotal;

    // -----------------------------
    // Push values to Foxy
    // -----------------------------

    // 1) Put base print price on the size radio
    setPriceValue(sizeEl, sizePrice);

    // 2) Put frame price on the frame radio (or nothing if no frame)
    setPriceValue(frameEl, frameTotal);

    // 3) For any selected option that contributes adjustments, set its delta
    for (const el of selected) {
      if (el.hasAttribute('data-adj-mult') || el.hasAttribute('data-adj-add')) {
        const delta = onSale(calcAdjustmentDelta(el, basePrintPrice));
        setPriceValue(el, delta);
      }
    }

    // 4) For selected radios that define base (substrate, GW, paper type, etc.),
    //    we do NOT want them adding price directly since base is handled by size.
    //    Set them to 0 so Foxy doesn't double-count.
    for (const el of selected) {
      if (el.hasAttribute('data-base-key')) {
        setPriceValue(el, 0);
      }
    }

    // -----------------------------
    // Display
    // -----------------------------
    for (const el of priceEls) el.textContent = money(totalPrice);
    for (const el of document.querySelectorAll('[data-adc-price="original"]')) el.textContent = money(fullPrice);
    for (const el of document.querySelectorAll('[data-adc-price="savings"]')) el.textContent = money(fullPrice - totalPrice);
  }

  // Listen to changes on any radio; this avoids missing future option groups
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t && t.matches && t.matches('input[type="radio"]')) recalc();
  });

  // A sale starting or ending while the page is open.
  document.addEventListener('adc-sale-change', recalc);

  recalc();
});

  })(); } catch (e) { console.error('[adc] pricing-calc.js failed', e); }

  /* ===== JS/ui-visibility.js (product pages only) ===== */
  if (isProductPage) try { (function () {
// UI visibility
// ---------------------------------------------------------------------------
// updateAllVisibility(state) shows/hides the option sections that depend on the
// current substrate and canvas format, clears selections that stop being
// offerable, and puts back the ones the customer had before.
//
// `state` comes straight from frame-substrate-var-updates.js, which computed
// those booleans moments earlier. Previously this file read them back out of
// the CSS custom properties with six separate getComputedStyle() calls, each of
// which forces a style recalculation — to recover values that were already
// sitting in a variable one file over.
//
// The `state` argument is optional. If it's missing (load-order accident, or a
// manual call from the console) we fall back to one getComputedStyle read
// instead of six.
//
// One pass is: clear what no longer applies -> restore what does -> fall back
// to None -> announce it once. Each step is guarded so a pass with nothing to
// do writes nothing and fires no events.

// ---------------------------------------------------------
//  Checking and unchecking, symmetrically
// ---------------------------------------------------------
// Webflow's custom radios keep their visual state in a class, not only in the
// `checked` property. These two have to mirror each other exactly: an earlier
// version cleared both but restored only `checked`, which left a radio really
// selected — satisfying its group's `required`, lighting the add-to-cart button
// — while still drawing as unselected. The button was right and the radio
// looked wrong.
function checkRadio(input) {
  input.checked = true;
  input.classList.add('w--redirected-checked');

  const wrapper = input.closest('.w-radio');
  if (wrapper) wrapper.classList.add('w--redirected-checked');
}

function uncheckRadio(input) {
  input.checked = false;
  input.classList.remove('w--redirected-checked');

  const wrapper = input.closest('.w-radio');
  if (wrapper) wrapper.classList.remove('w--redirected-checked');
}

// ---------------------------------------------------------
//  Selection memory
// ---------------------------------------------------------
// Switching substrate clears the finish you had picked, so bouncing
// Canvas → Paper → Canvas used to lose the canvas finish entirely. We remember
// what was cleared and put it back when it becomes offerable again.
//
// This does NOT replace clearing. A stale checked radio in a hidden section is
// still read by pricing-calc.js, updateSubstrateBlur(), the Foxy submission,
// and — worst — satisfies its group's `required`, which would light the
// add-to-cart button for an option the customer never chose. So we still clear;
// we just keep a copy.
//
// Keyed by scope — one slot per section, or per frame tab — never by group.
// `finish` is one group spread across the canvas, paper and metal sections, so
// a group key meant clearing the paper finish overwrote the remembered canvas
// one, and the canvas finish never came back.
//
// The scope comes from the same data attributes the rest of the page is
// extended with, so a new option section or frame type gets memory for free.
//
// Entries are re-inserted on every capture so Map iteration order tracks
// recency, and the restore sweep walks it backwards: the last thing you had is
// the first thing offered back.
//
// Stores the element itself rather than an id: this page has duplicate ids
// (gallery-wrap and stretched-canvas both resolve to a code embed, not the
// input), so getElementById is a trap here. Hidden sections are only
// display:none'd, never detached, so the references stay valid.
const rememberedSelections = new Map();

const CANVAS_FORMAT_SCOPE = 'section:canvas-format';

// Frame radios carry data-frame-type on themselves; everything else sits inside
// a data-framer-section. #none is excluded: it is the fallback the code selects
// when a frame is ruled out, so remembering it would let the machine's answer
// come back as though it were the customer's.
function scopeOf(input) {
  if (input.id === 'none') return null;
  if (input.dataset.frameType) return `frame:${input.dataset.frameType}`;

  const section = input.closest('[data-framer-section]');
  return section ? `section:${section.dataset.framerSection}` : null;
}

// Memory is "the last thing you had in this scope", which means capturing your
// selections as you make them — not only the ones this file takes away.
//
// Without this, replacing a selection inside a scope that stays on screen goes
// unrecorded: on metal the floater tab remains offerable, so picking a
// shadowbox unchecks the floater natively, nothing captures it, and returning
// to canvas has no floater to put back and falls to None. Clearing alone could
// never see that, because nothing was cleared.
function rememberSelection(input) {
  const scope = scopeOf(input);
  if (!scope) return;

  // delete-then-set moves the entry to the end, so Map order is recency.
  rememberedSelections.delete(scope);
  rememberedSelections.set(scope, input);
}

document.addEventListener(
  'change',
  e => {
    const el = e.target;
    if (!el || !el.matches || !el.matches('input[type="radio"]') || !el.checked) return;

    // isTrusted is the browser's own record of a real interaction. announceChange()
    // dispatches synthetic events, which report false — so this cannot mistake our
    // own fallback for the customer picking No Frame.
    if (el.id === 'none' && e.isTrusted) noFrameWasAutomatic = false;

    rememberSelection(el);
  },
  true,
);

// ---------------------------------------------------------
//  Helper: clear radios inside any container
// ---------------------------------------------------------
// Returns how many radios were actually unchecked, so callers can tell a
// no-op pass from one that took a selection away from the customer.
function clearRadiosIn(containerSelector) {
  let cleared = 0;

  document.querySelectorAll(`${containerSelector} input[type="radio"]`).forEach(input => {
    if (input.checked) {
      cleared++;
      rememberSelection(input);
    }
    uncheckRadio(input);
  });

  return cleared;
}

// ---------------------------------------------------------
//  Helper: does this group hold a real answer?
// ---------------------------------------------------------
// #none counts only when the customer chose it.
//
// selectNoFrame() fills an emptied frame group with #none, and that must not
// count — otherwise the automatic fallback permanently blocks a remembered
// frame from coming back. But a None the customer clicked themselves is a real
// answer, and treating it as "no answer" meant memory restored the previous
// frame over it on the very next pass: clicking No Frame appeared to do nothing
// at all.
//
// An earlier version relied on "a deliberate None is safe because nothing was
// cleared, so there is nothing to restore over it". That stopped being true the
// moment memory started capturing every selection as it was made, rather than
// only what this file took away — and nothing caught it, because the two
// changes were months of context apart.
function groupHasRealAnswer(name) {
  const checked = document.querySelector(`input[name="${name}"]:checked`);
  if (!checked) return false;
  if (checked.id === 'none') return !noFrameWasAutomatic;
  return true;
}

// Whether the current #none was put there by selectNoFrame() rather than by the
// customer. Set below when we select it; cleared by a trusted change event,
// which is the browser's own record of a real interaction — our synthetic
// announcements carry isTrusted false and so cannot clear it by accident.
let noFrameWasAutomatic = false;

// ---------------------------------------------------------
//  Helper: is this option currently on offer?
// ---------------------------------------------------------
// Walks inline display only, which is precisely the hiding this file does. A
// frame sitting in a non-active Webflow tab pane is hidden by a stylesheet
// class, not inline, so it still counts as offerable — it is a legitimate
// choice the customer simply is not looking at. A frame whose whole type was
// ruled out does carry inline display:none, and does not.
function isOfferable(input) {
  for (let el = input; el && el !== document.body; el = el.parentElement) {
    if (el.style && el.style.display === 'none') return false;
  }
  return true;
}

// ---------------------------------------------------------
//  Helper: put a remembered selection back
// ---------------------------------------------------------
// Guarded on the group being empty. If the customer has already chosen
// something we leave it alone — memory is a fallback for an abandoned group,
// never an override of a live answer.
//
// Sweeps the whole memory rather than consulting a hardcoded list of sections
// and the conditions under which each is shown — the DOM already knows which
// containers this pass left visible, so offerability is read from it.
//
// Walks backwards for recency. Once a group is filled, groupHasRealAnswer stops
// any older entry for that same group from firing in the same sweep.
//
// Returns the last element it restored, or null. The caller batches the change
// notification; this deliberately fires no event of its own.
function restoreScope(scope) {
  const input = rememberedSelections.get(scope);
  if (!input) return null;

  if (groupHasRealAnswer(input.name)) return null;
  if (!isOfferable(input)) return null;

  rememberedSelections.delete(scope);
  checkRadio(input);
  revealInScroller(input);

  return input;
}

function restoreOfferableSelections() {
  let restored = null;

  [...rememberedSelections.keys()].reverse().forEach(scope => {
    restored = restoreScope(scope) || restored;
  });

  return restored;
}

// A restored frame can sit outside the visible slice of its horizontal
// scroller, which makes the restore look like it did nothing. Scrolls the
// container only — never the page — so this cannot yank the viewport around.
// Writing scrollLeft fires a scroll event, which is what frame-scroll.js
// already listens to for its custom thumb, so the two stay in sync for free.
//
// Reads rects, so it forces a layout — acceptable here because it runs only on
// an actual restore, not on every visibility pass.
function revealInScroller(input) {
  const grid = input.closest('.frames-grid');
  if (!grid) return;

  const item = input.closest('.cms-thumbnail') || input;
  const gridRect = grid.getBoundingClientRect();
  const itemRect = item.getBoundingClientRect();

  const centred = (itemRect.left - gridRect.left) - (gridRect.width - itemRect.width) / 2;
  grid.scrollLeft = Math.max(0, grid.scrollLeft + centred);
}

// ---------------------------------------------------------
//  Availability: a hidden option must not be a required one
// ---------------------------------------------------------
// `required` on radios is evaluated per group *name*, not per element, so a
// group is satisfied by any one member — but a group whose every member is
// hidden can never be satisfied at all. The form then cannot validate, the
// add-to-cart button never lights, and clicking it reports against a control
// nobody can see.
//
// Disabled controls are skipped by constraint validation entirely, so the rule
// is simply: if you cannot be chosen, you are not required. This also keeps
// hidden options out of the Foxy submission.
//
// Replaces a hand-written version of exactly this that existed for
// canvas-format alone — the only group that used to need it, because it was the
// only one whose every member could be hidden at once. Deleting the canvas
// finish made `finish` a second such group on canvas, which is what generalised
// it. Any future section gets this for free.
//
// Derived from the DOM at the end of the pass rather than applied alongside
// each setDisplay() call, which would be order-dependent: the frames section
// contains the frame tabs, so showing the outer one would re-enable radios the
// inner one had just disabled.
//
// isOfferable() reads inline display — the hiding this file does — so a frame
// sitting in a non-active Webflow tab pane stays enabled. It is a legitimate
// choice the customer simply is not looking at. Reads style attributes only, so
// no layout is forced.
function syncRadioAvailability() {
  document.querySelectorAll('input[type="radio"]').forEach(input => {
    input.disabled = !isOfferable(input);
  });
}

// ---------------------------------------------------------
//  Helper: fall back to the "None" frame
// ---------------------------------------------------------
// When a frame stops being compatible we clear it — but leaving the group empty
// is a worse state than saying "no frame", which is what the customer
// effectively now has. #none lives in the frames section outside all three tab
// panes, so it is always reachable no matter which frame type was ruled out.
//
// Bails if anything in the group is checked, not just #none, which makes the
// ordering against restoreGroup() safe: if memory just put a frame back, this
// quietly does nothing.
//
// Returns the element it checked, or null. Like restoreGroup(), it leaves the
// event to the caller.
function selectNoFrame() {
  if (document.querySelector('input[name="frame"]:checked')) return null;

  const none = document.getElementById('none');
  if (!none) return null;

  checkRadio(none);
  noFrameWasAutomatic = true;
  return none;
}

// One change event per pass, not one per selection we touched.
//
// pricing-calc.js recalculates on every change it hears, independently of the
// rAF coalescing in frame-substrate-var-updates.js. Firing separately for a
// restore and then for the None fallback made it price a half-reconciled
// configuration first — the wrong number that flashed in the total. Reconciling
// fully and announcing once removes that window.
function announceChange(input) {
  if (!input) return;
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

// ---------------------------------------------------------
//  Helper: set active tab
// ---------------------------------------------------------
function ensureOneVisibleTabActive(tabsSelector) {
  const tabs = document.querySelector(tabsSelector);
  if (!tabs) return;

  const links = [...tabs.querySelectorAll('[role="tab"]')];

  const active = links.find(l => isVisible(l) && l.getAttribute('aria-selected') === 'true');
  if (active) return;

  const firstVisible = links.find(l => isVisible(l));
  if (firstVisible) firstVisible.click();
}

function isVisible(el) {
  return !!(el.offsetParent || el.getClientRects().length);
}

// ---------------------------------------------------------
//  Helper: bulk display toggle
// ---------------------------------------------------------
function setDisplay(selector, shown) {
  document.querySelectorAll(selector).forEach(el => {
    el.style.display = shown ? '' : 'none';
  });
}

// ---------------------------------------------------------
//  Fallback: read flags from CSS if no state was passed in
// ---------------------------------------------------------
function readStateFromCss() {
  const s = getComputedStyle(document.documentElement);
  const flag = name => s.getPropertyValue(name).trim() === '1';

  return {
    isCanvas: flag('--sub-canvas'),
    isMetal: flag('--sub-metal'),
    isPaper: flag('--sub-paper'),
    isLooseCanvas: flag('--loose-canvas'),
  };
}

// ---------------------------------------------------------
//  Master visibility function
// ---------------------------------------------------------
function updateAllVisibility(state) {
  const { isCanvas, isMetal, isPaper, isLooseCanvas } = state || readStateFromCss();

  // --- 1. Canvas sections ------------------------------------------------
  // The canvas-finish selectors here and below are deliberately kept even
  // though that section no longer exists: they match nothing, cost nothing, and
  // mean the option can be re-added in the Designer — with its
  // data-framer-section attribute — and start working again with no code change.
  setDisplay('[data-framer-section="canvas-finish"], [data-framer-section="canvas-format"]', isCanvas);

  if (!isCanvas) {
    clearRadiosIn('[data-framer-section="canvas-finish"]');
    clearRadiosIn('[data-framer-section="canvas-format"]');
  }

  // --- 2. Paper sections -------------------------------------------------
  setDisplay('[data-framer-section="paper-type"]', isPaper);
  if (!isPaper) clearRadiosIn('[data-framer-section="paper-type"]');

  // --- 3. Metal sections -------------------------------------------------
  // Metal has a finish but no format; only canvas has a format.
  setDisplay('[data-framer-section="metal-finish"]', isMetal);
  if (!isMetal) clearRadiosIn('[data-framer-section="metal-finish"]');

  // --- 3b. Canvas format: restore it, then read it -----------------------
  // Restored ahead of the frame sections rather than in the sweep at the end,
  // because gallery wrap decides which frame tabs exist. Doing it afterwards
  // meant the frame logic ran against the previous format, cleared a frame and
  // repriced, then the next pass put it all back — a flicker in the preview and
  // a wrong number in the total.
  //
  // Restoring the format here is also what lets a whole canvas configuration
  // come back together: gallery wrap returns, which makes the floater tab
  // offerable again, and the sweep below then finds the floater frame that was
  // remembered on the way out. Each substrate keeps its own configuration.
  let restoredFormat = null;
  if (isCanvas) restoredFormat = restoreScope(CANVAS_FORMAT_SCOPE);

  // Read from the DOM, never from `state`. That snapshot was computed before
  // this pass ran, so on the way out of canvas it still says "gallery wrap"
  // while section 1 above has already cleared the format — and it cannot know
  // about the restore that just happened either.
  const format = document.querySelector('input[name="canvas-format"]:checked');
  const galleryWrap = !!format && format.id === 'gallery-wrap';

  // --- 4. Floater + gallery-wrap frames ----------------------------------
  // framesCleared tracks only the frame group; the substrate and finish clears
  // above are not eligible for the None fallback.
  //
  // The rule for frames across a substrate change is simply compatibility: a
  // frame that is still offerable is kept, one that is not is cleared and
  // remembered, and the sweep restores whatever that substrate last had. #none
  // is compatible with every substrate — it sits outside all three tab panes —
  // so it is never cleared and simply persists, which is correct. No special
  // case is needed, and an earlier attempt to add one (dropping a deliberate
  // No Frame whenever the substrate changed) was wrong.
  let framesCleared = 0;

  const isFloaterVisible = isMetal || (isCanvas && galleryWrap);

  setDisplay('[data-frame-type="floater"]', isFloaterVisible);
  if (!isFloaterVisible) framesCleared += clearRadiosIn('[data-frame-type="floater"]');

  setDisplay('[data-frame-type="standard"], [data-frame-type="shadowbox"]', !galleryWrap);
  if (galleryWrap) {
    framesCleared += clearRadiosIn('[data-frame-type="standard"]');
    framesCleared += clearRadiosIn('[data-frame-type="shadowbox"]');
  }

  // --- 5. Loose-canvas frame suppression ---------------------------------
  // DORMANT: loose canvas is temporarily not offered, so no radio carries that
  // id and isLooseCanvas is always false. Kept whole and working so the option
  // can come back by re-adding the radio in the Designer — no code change here.
  setDisplay('[data-framer-section="frames"]', !isLooseCanvas);

  if (isLooseCanvas) {
    framesCleared += clearRadiosIn('[data-frame-type="standard"]');
    framesCleared += clearRadiosIn('[data-frame-type="shadowbox"]');
    framesCleared += clearRadiosIn('[data-frame-type="floater"]');
  }

  // --- 5c. Availability ---------------------------------------------------
  // After every display change above has landed, before the reconcile below so
  // anything restored is already enabled.
  syncRadioAvailability();

  // --- 6. Reconcile: restore, then fall back, then announce once ---------
  // A single phase after every clear above, never interleaved with them.
  // `finish` is one group spread across three substrate sections, so restoring
  // the canvas finish while the paper finish was still checked would hit the
  // "group already answered" guard and silently do nothing.
  let touched = restoreOfferableSelections() || restoredFormat;

  // Runs after the restore so a remembered frame beats the None fallback.
  if (framesCleared) touched = selectNoFrame() || touched;

  announceChange(touched);

  // --- 7. Settle the tab strip -------------------------------------------
  // Once, at the end, after every display change above has landed. This used
  // to run seven times per pass — including once per element inside a forEach —
  // and each call reads offsetParent/getClientRects on every tab link, forcing
  // a synchronous layout each time.
  ensureOneVisibleTabActive('#frame-tabs');
}

window.updateAllVisibility = updateAllVisibility;

  })(); } catch (e) { console.error('[adc] ui-visibility.js failed', e); }

  /* ===== JS/frame-scroll.js (product pages only) ===== */
  if (isProductPage) try { (function () {
// Custom scrollbar — syncs a .f-scroll-track / .f-scroll-thumb pair to a
// real .scroll-wrapper element's native scroll position, and lets dragging
// the thumb (or clicking the track) drive that scroll position back.
//
// Paste into a Webflow code Embed (or Page Settings > Custom Code > Footer).
// Handles multiple instances on the same page (e.g. one per tab pane),
// matching each .scroll-wrapper to the .f-scroll-track at the same index.

// Waits for storefront-*.js content when present (ADC_READY); otherwise plain DOMContentLoaded.
(window.ADC_READY ? (fn) => window.ADC_READY.then(() => fn()) : (fn) => document.addEventListener('DOMContentLoaded', fn))(function () {
  // Frame thumbnails ship with loading="lazy" (set on the Designer sample image in the Webflow
  // Designer, not in this repo), so with nothing done none fetch until
  // the Frames section is scrolled into view and the picker looks empty on
  // arrival. Fix that for the first few frames of each visible grid only.
  // Forcing ALL of them eager was tried: ~55 frames x 3-19KB JPEGs (r2.dev,
  // HTTP/1.1, 6 connections) queued for ~10s and held the load event hostage
  // (measured 2026-10-26: 12.8s load, ~2MB of frame images). The rest stay
  // lazy and load as the shopper scrolls the grid, or when a hidden tab is
  // shown (native lazy loading handles both).
  // Native lazy loading keeps the real src/srcset (no placeholder swap), so
  // re-setting them after flipping loading="eager" forces an immediate
  // fetch regardless of scroll position.
  var EAGER_FRAMES_PER_GRID = 8; // ~3 columns are on screen at once; the rest is read-ahead
  document.querySelectorAll('.frames-grid').forEach(function (grid) {
    // A grid in a hidden tab/section has no layout boxes; its lazy images load on reveal.
    if (!grid.getClientRects().length) return;
    Array.prototype.slice.call(grid.children, 0, EAGER_FRAMES_PER_GRID).forEach(function (item) {
      item.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
        ['src', 'srcset'].forEach(function (attr) {
          var value = img.getAttribute(attr);
          if (value) {
            img.removeAttribute(attr);
            img.setAttribute(attr, value);
          }
        });
      });
    });
  });

  var wrappers = document.querySelectorAll('.frames-grid');
  var tracks = document.querySelectorAll('.f-scroll-track');

  wrappers.forEach(function (wrapper, i) {
    var track = tracks[i];
    var thumb = track ? track.querySelector('.f-scroll-thumb') : null;
    if (!track || !thumb) return;

    function updateThumb() {
      var ratio = wrapper.clientWidth / wrapper.scrollWidth;
      var thumbWidth = Math.max(ratio * track.clientWidth, 30);
      thumb.style.width = thumbWidth + 'px';

      var maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
      var maxThumbPos = track.clientWidth - thumbWidth;
      var pos = maxScroll > 0 ? (wrapper.scrollLeft / maxScroll) * maxThumbPos : 0;
      thumb.style.left = pos + 'px';
    }

    wrapper.addEventListener('scroll', updateThumb);
    window.addEventListener('resize', updateThumb);
    updateThumb();

    // Drag the thumb to scroll.
    var dragging = false;
    var startX = 0;
    var startScroll = 0;

    thumb.addEventListener('pointerdown', function (e) {
      dragging = true;
      startX = e.clientX;
      startScroll = wrapper.scrollLeft;
      thumb.setPointerCapture(e.pointerId);
    });

    thumb.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      var maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
      var maxThumbPos = track.clientWidth - thumb.offsetWidth;
      wrapper.scrollLeft = startScroll + (dx / maxThumbPos) * maxScroll;
    });

    thumb.addEventListener('pointerup', function () {
      dragging = false;
    });

    // Click anywhere on the track (not the thumb) to jump to that position.
    track.addEventListener('click', function (e) {
      if (e.target === thumb) return;
      var rect = track.getBoundingClientRect();
      var clickRatio = (e.clientX - rect.left) / rect.width;
      var maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
      wrapper.scrollLeft = clickRatio * maxScroll;
    });
  });
});

  })(); } catch (e) { console.error('[adc] frame-scroll.js failed', e); }

  /* ===== JS/studio.js (product pages only) ===== */
  if (isProductPage) try { (function () {
// Frame studio: the preview + panel behaviour of the EXPERIMENTAL product page /artwork-detail-experiment
// (built 2026-11-03). Does nothing on a page without [data-studio-stage], so it is safe in the bundle.
// CSS: CSS/studio.css. Everything is keyed by data-studio-* attributes, never class names, so Designer
// class renames cannot break it.
//
// HOW THE FRAME IS DRAWN
// The frame is ONE element ([data-studio-piece]) with a CSS border-image. The border's width is
// calc(frame inches x pixels-per-inch), and pixels-per-inch comes from container query units on the
// stage, so the whole preview resizes with pure CSS (studio.css). The only thing JS does is turn the
// frame's moulding STRIP (frames.strip_url: 1200px long, height = visible width in inches x 100, floater
// strips include the 0.25" gap) into a 9-slice image with mitred corners, on a <canvas>, when the frame
// is picked. No extra image is downloaded for that: the strip is the same file the swatch already shows.
// Needs CORS on the image host (Supabase Storage sends it; the R2 frames bucket got a rule 2026-11-03).
//
// Contract (all optional except the stage):
//   [data-studio-stage]            the preview area (a size container). Gets --art-w/--art-h/--fw/--lip
//                                  (inches), --frame-sheet, --slice, --mx/--my (light position 0-1),
//                                  data-studio-frame="none|standard|floater|shadowbox",
//                                  data-studio-light="on|off".
//   [data-studio-piece]            the framed piece; holds [data-studio-art] with the artwork <img>.
//   [data-studio-light-toggle]     button: switches the lighting (aria-pressed mirrors it).
//   [data-studio-light-hint]       shown for 3s when the lighting turns itself on.
//   [data-studio-sel="<group>"]    text = the chosen option of that radio group ("" when none).
//   [data-studio-sel-row="<group>"] hidden while that group has no answer or is not on offer.
//   [data-studio-total]            text = outside size incl. frame, e.g. 17.75 × 21.75 in
//   [data-studio-todo]             text = what is still to choose, e.g. "Size · Frame" ("" when done);
//                                  labels come from data-studio-label on the closest [data-studio-section].
//   [data-studio-tab="<type>"] / [data-studio-pane="<type>"]  frame-type tabs (put the tabs inside
//                                  #frame-tabs with role="tab" so ui-visibility.js can settle them).

(function () {
  const stage = document.querySelector('[data-studio-stage]');
  if (!stage) return;

  const ready = window.ADC_READY || new Promise((r) => document.addEventListener('DOMContentLoaded', r));
  const form = document.querySelector('form.product-form') || stage.closest('form') || document.querySelector('form');
  const setVar = (k, v) => stage.style.setProperty(k, v);
  const LIP_IN = 0.25; // a standard/shadowbox frame's rabbet covers 1/4" of the print on each side

  // ---------------------------------------------------------------- frame sheet (strip -> 9-slice)
  const sheets = new Map(); // strip url -> Promise<{ url, slice, inches }>
  let currentSheetUrl = '';

  function drawSheet(img) {
    const T = img.naturalHeight; // moulding thickness in px (100px = 1in)
    const E = Math.min(img.naturalWidth, 600); // edge run kept in the sheet; border-image-repeat: round tiles it
    const S = E + 2 * T;
    const c = document.createElement('canvas');
    c.width = c.height = S;
    const g = c.getContext('2d');
    const pattern = g.createPattern(img, 'repeat-x');
    const o = 0.75; // overlap past the mitre so the corners have no hairline gap
    for (let k = 0; k < 4; k++) {
      // Each side is the TOP side rotated a quarter turn: the strip's top row is the frame's outer edge.
      g.save();
      g.translate(S / 2, S / 2);
      g.rotate((k * Math.PI) / 2);
      g.translate(-S / 2, -S / 2);
      g.beginPath();
      g.moveTo(-o, -o);
      g.lineTo(S + o, -o);
      g.lineTo(S - T + o, T + o);
      g.lineTo(T - o, T + o);
      g.closePath();
      g.clip();
      g.fillStyle = pattern;
      g.fillRect(0, 0, S, T + 1);
      g.restore();
    }
    return new Promise((resolve, reject) => {
      c.toBlob((blob) => (blob ? resolve({ blob, slice: T, inches: T / 100 }) : reject(new Error('toBlob failed'))), 'image/webp', 0.92);
    });
  }

  function getSheet(src) {
    if (sheets.has(src)) return sheets.get(src);
    const p = new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error(`frame strip failed to load: ${src}`));
      img.src = src;
    })
      .then(drawSheet)
      .then(({ blob, slice, inches }) => ({ url: URL.createObjectURL(blob), slice, inches }));
    sheets.set(src, p);
    p.catch(() => sheets.delete(src));
    // Keep at most 8 sheets (each is a few MB once decoded); never drop the one on screen.
    if (sheets.size > 8) {
      for (const [key, value] of sheets) {
        if (key === src) continue;
        value.then((s) => { if (s.url !== currentSheetUrl) URL.revokeObjectURL(s.url); }).catch(() => {});
        sheets.delete(key);
        break;
      }
    }
    return p;
  }

  // ---------------------------------------------------------------- reading the form
  const checked = (name) => document.querySelector(`input[type="radio"][name="${name}"]:checked`);
  const cleanValue = (input) => (input ? String(input.value || '').replace(/\{[^}]*\}/g, '').trim() : '');
  const labelOf = (input) => {
    if (!input) return '';
    const own = input.closest('[data-studio-option]')?.querySelector('[data-adc-bind="label"],[data-adc-bind="name"]');
    const text = own?.textContent.trim();
    return text || cleanValue(input);
  };

  let artRatio = 0; // natural width / height of the artwork image, once known
  const artImg = stage.querySelector('[data-studio-art] img');
  function readArtRatio() {
    if (artImg && artImg.naturalWidth && artImg.naturalHeight && !artImg.hasAttribute('data-adc-placeholder')) {
      artRatio = artImg.naturalWidth / artImg.naturalHeight;
    }
  }
  if (artImg) artImg.addEventListener('load', () => { readArtRatio(); update(); });

  function artInches() {
    const size = checked('size');
    let w = parseFloat(size?.dataset.sWidth);
    let h = parseFloat(size?.dataset.height);
    if (w > 0 && h > 0) {
      // Sizes are listed portrait-first for some catalogs; follow the artwork's orientation.
      if (artRatio && (artRatio > 1) !== (w > h) && w !== h) [w, h] = [h, w];
      return { w, h, chosen: true };
    }
    const r = artRatio || 0.8;
    return r >= 1 ? { w: 24, h: 24 / r, chosen: false } : { w: 24 * r, h: 24, chosen: false };
  }

  // ---------------------------------------------------------------- applying
  let frameToken = 0;
  let frameState = { type: 'none', inches: 0, lip: 0 };
  const fmt = (n) => (Math.round(n * 100) / 100).toString();

  function applyFrame() {
    const input = checked('frame');
    const type = input && input.id !== 'none' ? input.dataset.frameType || 'standard' : 'none';
    const strip = input && type !== 'none' ? input.dataset.frameStrip : '';
    const token = ++frameToken;

    if (!strip) {
      frameState = { type: 'none', inches: 0, lip: 0 };
      currentSheetUrl = '';
      stage.removeAttribute('data-studio-loading');
      setVar('--frame-sheet', 'none');
      setVar('--fw', '0');
      setVar('--lip', '0');
      stage.setAttribute('data-studio-frame', type === 'none' ? 'none' : type);
      writeTotals();
      return;
    }

    stage.setAttribute('data-studio-loading', '');
    getSheet(strip)
      .then((sheet) => {
        if (token !== frameToken) return;
        const lip = type === 'floater' ? 0 : LIP_IN;
        frameState = { type, inches: sheet.inches, lip };
        currentSheetUrl = sheet.url;
        setVar('--frame-sheet', `url("${sheet.url}")`);
        setVar('--slice', String(sheet.slice));
        setVar('--fw', String(sheet.inches));
        setVar('--lip', String(lip));
        stage.setAttribute('data-studio-frame', type);
        stage.removeAttribute('data-studio-loading');
        writeTotals();
      })
      .catch((e) => {
        if (token !== frameToken) return;
        console.error('[studio]', e.message);
        stage.removeAttribute('data-studio-loading');
      });
  }

  function writeTotals() {
    const art = artInches();
    setVar('--art-w', fmt(art.w));
    setVar('--art-h', fmt(art.h));
    const add = 2 * (frameState.inches - frameState.lip);
    const text = art.chosen ? `${fmt(art.w + add)} × ${fmt(art.h + add)} in` : '';
    document.querySelectorAll('[data-studio-total]').forEach((el) => { el.textContent = text; });
  }

  function isOnOffer(input) {
    return !input.disabled;
  }

  function writeSelection() {
    document.querySelectorAll('[data-studio-sel]').forEach((el) => {
      const input = checked(el.getAttribute('data-studio-sel'));
      el.textContent = input && isOnOffer(input) ? labelOf(input) : '';
    });
    document.querySelectorAll('[data-studio-sel-row]').forEach((el) => {
      const name = el.getAttribute('data-studio-sel-row');
      const input = checked(name);
      const offered = [...document.querySelectorAll(`input[type="radio"][name="${name}"]`)].some(isOnOffer);
      el.hidden = !(input && isOnOffer(input)) || !offered;
    });

    // Still to choose: every required group that is on offer and unanswered, in page order.
    const todo = [];
    const seen = new Set();
    document.querySelectorAll('input[type="radio"][required]').forEach((input) => {
      const name = input.name;
      if (seen.has(name) || !isOnOffer(input)) return;
      seen.add(name);
      if (checked(name)) return;
      const label = input.closest('[data-studio-section]')?.getAttribute('data-studio-label') || name;
      todo.push(label);
    });
    const todoText = todo.join(' · ');
    document.querySelectorAll('[data-studio-todo]').forEach((el) => {
      el.textContent = todoText;
      el.closest('[data-studio-todo-row]')?.toggleAttribute('hidden', !todoText);
    });
    return todo.length === 0;
  }

  // ---------------------------------------------------------------- lighting
  const lightBtn = document.querySelector('[data-studio-light-toggle]');
  let lightTouched = false;
  let wasComplete = false;
  function setLight(on, auto) {
    stage.setAttribute('data-studio-light', on ? 'on' : 'off');
    if (lightBtn) lightBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (auto && on) {
      const hint = document.querySelector('[data-studio-light-hint]');
      if (hint) {
        hint.setAttribute('data-studio-show', '');
        setTimeout(() => hint.removeAttribute('data-studio-show'), 3000);
      }
    }
  }
  setLight(false);
  if (lightBtn) {
    lightBtn.addEventListener('click', (e) => {
      e.preventDefault();
      lightTouched = true;
      setLight(stage.getAttribute('data-studio-light') !== 'on');
    });
  }

  // The light follows the pointer over the stage (CSS eases it via @property). Off the stage it drifts
  // back to a soft top-left key light.
  let px = 0.3;
  let py = 0.25;
  let pending = false;
  function writeLight() {
    pending = false;
    setVar('--mx', px.toFixed(3));
    setVar('--my', py.toFixed(3));
  }
  function queueLight() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || ((f) => setTimeout(f, 16)))(writeLight);
  }
  const reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion) {
    stage.addEventListener('pointermove', (e) => {
      const r = stage.getBoundingClientRect();
      px = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
      py = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
      queueLight();
    });
    stage.addEventListener('pointerleave', () => { px = 0.3; py = 0.25; queueLight(); });
  }
  writeLight();

  // ---------------------------------------------------------------- frame-type tabs
  function selectTab(type) {
    document.querySelectorAll('[data-studio-tab]').forEach((tab) => {
      const on = tab.getAttribute('data-studio-tab') === type;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.toggleAttribute('data-studio-active', on);
    });
    document.querySelectorAll('[data-studio-pane]').forEach((pane) => {
      pane.toggleAttribute('data-studio-active', pane.getAttribute('data-studio-pane') === type);
    });
  }
  document.querySelectorAll('[data-studio-tab]').forEach((tab) => {
    tab.setAttribute('role', 'tab');
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      selectTab(tab.getAttribute('data-studio-tab'));
    });
  });

  // ---------------------------------------------------------------- one pass
  let scheduled = false;
  function update() {
    scheduled = false;
    readArtRatio();
    applyFrame();
    writeTotals();
    const substrate = checked('substrate');
    stage.setAttribute('data-studio-substrate', substrate ? (substrate.dataset.sub || substrate.id || '').toLowerCase() : 'none');
    const complete = writeSelection();
    if (complete && !wasComplete && !lightTouched) setLight(true, true);
    wasComplete = complete;
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    // After frame-substrate-var-updates.js / ui-visibility.js have reconciled (they run in rAF too).
    setTimeout(update, 0);
  }

  ready.then(() => {
    const firstTab = document.querySelector('[data-studio-tab]');
    if (firstTab && !document.querySelector('[data-studio-tab][aria-selected="true"]')) selectTab(firstTab.getAttribute('data-studio-tab'));
    document.addEventListener('change', (e) => { if (e.target.matches('input[type="radio"]')) schedule(); });
    if (form) form.addEventListener('reset', schedule);
    update();
    setTimeout(update, 120); // after ui-visibility's first pass may have disabled sections
  });
})();

  })(); } catch (e) { console.error('[adc] studio.js failed', e); }
})();
